module.exports = __webpack_public_path__ + "static/assets/d97727af4f3e1eb2537d796a13ce7d04.svg";